export const displayModifierDefault = (arg0: string | number | undefined) =>
  arg0;

export const displayDeModifierDefault = (arg0: string | number | undefined) =>
  arg0;

export const MASK_DELAY = 500;
